import React from 'react'
import {Row, Col} from 'antd'
import PropTypes from 'prop-types'
//Model

// Components
import ViewTable from '../../../Table/ViewTable'
import Button from '../../../Buttons'
import RowTools from "../../../Table/RowTools";
import helper from "../../../../helper/helper";
import NNNTModal from "../Modal";

// Columns
const columns_form = (showEditModal, deleteRowModal) => [
  {
    title: "#",
    dataIndex: "stt",
    width: "50px",
  },
  {
    title: "Lượng nước mùa khô (triệu m3)",
    dataIndex: "luongNuocMuaKho",
  },
  {
    title: "Lượng nước mùa mưa (triệu m3)",
    dataIndex: "luongNuocMuaMua",
  },
  {
    title: "Lượng nước cả năm (triệu m3)",
    dataIndex: "luongNuocCaNam",
    width: "100px",
  },
  {
    title: "Năm",
    dataIndex: "nam",
    width: "80px",
  },
  {
    title: "Thao tác",
    render: (value, row) => (
      <RowTools row={row} deleteRowModal={() => deleteRowModal(row)} showEditModal={showEditModal}/>
    ),
    width: "80px"
  },
];

const columns_presentation = (handleShowDetail) => [
  {
    title: "#",
    dataIndex: "stt",
    width: "50px",
  },
  {
    title: "Lượng nước mùa khô (triệu m3)",
    dataIndex: "luongNuocMuaKho",
  },
  {
    title: "Lượng nước mùa mưa (triệu m3)",
    dataIndex: "luongNuocMuaMua",
  },
  {
    title: "Lượng nước cả năm (triệu m3)",
    dataIndex: "luongNuocCaNam",
    width: "100px",
  },
  {
    title: "Năm",
    dataIndex: "nam",
    width: "100px",
  },
];

export default class TCQ extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      isAddModalOpen: false,
      isEditModalOpen: false,
      miningQuantity: [],
      selectedRow: null
    }
  }
  handleOpenAddModal = () => {
    this.setState({
      isAddModalOpen: true
    })
  };

  handleOpenEditModal = (row) => {
    this.setState({
      selectedRow: row,
      isEditModalOpen: true
    })
  };

  handleShowDetail = (row) => {
    this.setState({
      selectedRow: row,
    })
  };

  handleCloseModal = () => {
    this.setState({
      isAddModalOpen: false,
      isEditModalOpen: false,
      selectedRow: null
    })
  };

  handleAdd = (item) => {
    const {dataSource, handleUpdate} = this.props;
    const newData = [{...item}, ...dataSource];
    this.handleCloseModal();
    handleUpdate(newData);
  };

  handleEdit = (item) => {
    const {dataSource, handleUpdate, field} = this.props;
    const newData = helper.replaceItem(item, dataSource);
    this.handleCloseModal();
    handleUpdate(newData, field);
  };

  handleDelete = (item) => {
    const {dataSource, handleUpdate, field} = this.props;
    const newData = helper.removeItem(item, dataSource);
    handleUpdate(newData, field);
  };

  addSttToItems = (items) => {
    if (!items) return [];
    let newItems = [];
    if (items) {
      newItems = items.map((item, index) => ({...item, stt: index + 1,IdQdTCQ: 0}))
    }
    return newItems;
  };

  render() {
    const {isAddModalOpen, isEditModalOpen, selectedRow} = this.state;
    const {dataSource, mode} = this.props;

    return (
      <Row>
        <Row type="flex" justify="end" align="middle">
          {mode !== "view" &&
          <Button type="primary" onClick={this.handleOpenAddModal} icon="plus"/>}
        </Row>
        <div className="mt-10"/>
        <ViewTable
          bordered pagination={false}
          columns={mode !== "view" ? columns_form(this.handleOpenEditModal, this.handleDelete) : columns_presentation(this.handleShowDetail)}
          dataSource={this.addSttToItems(dataSource)}
          scroll={{ x: 500 }}
        />

        {isAddModalOpen &&
        <NNNTModal
          mode="form"
          isOpen={isAddModalOpen}
          handleCancel={this.handleCloseModal}
          handleOk={this.handleAdd}/>}

        {isEditModalOpen &&
        <NNNTModal
          mode="form"
          isEdit={true}
          initialValues={selectedRow}
          isOpen={isEditModalOpen}
          handleCancel={this.handleCloseModal}
          handleOk={this.handleEdit}/>}
      </Row>
    )
  }
}

TCQ.propTypes = {
  // MODE: string "form" and "presentation"
  mode: PropTypes.string.isRequired,
  dataSource: PropTypes.array.isRequired,
  handleUpdate: PropTypes.func,
};